// extracted by mini-css-extract-plugin
export var errorsContainer = "_tk-1";
export var link = "_tk-0";